(()=>{
  let content,owner,controller,resizeObserver;
  function init(root){
    controller?.abort();resizeObserver?.disconnect();
    controller=new AbortController();const options={signal:controller.signal};
    const rail=root.querySelector('.nr-ugc__rail'),cards=[...root.querySelectorAll('.nr-ugc__card')];
    const dialog=root.querySelector('dialog'),player=dialog.querySelector('video'),error=dialog.querySelector('.nr-ugc__error');
    const prev=root.querySelector('[data-nr-ugc-prev]'),next=root.querySelector('[data-nr-ugc-next]'),counter=root.querySelector('[data-nr-ugc-count]');
    let opener;
    function update(){
      const max=rail.scrollWidth-rail.clientWidth,step=cards.length>1?cards[1].offsetLeft-cards[0].offsetLeft:rail.clientWidth;
      prev.disabled=rail.scrollLeft<2;next.disabled=rail.scrollLeft>=max-2;
      counter.textContent=(Math.round(rail.scrollLeft/Math.max(1,step))+1)+' / '+cards.length;
    }
    function stop(){player.pause();player.removeAttribute('src');player.load();}
    function close(){if(dialog.open)dialog.close();}
    cards.forEach(card=>card.addEventListener('click',()=>{
      opener=card;error.hidden=true;player.poster=card.querySelector('img')?.currentSrc||'';
      player.src=card.dataset.nrUgcSrc;dialog.setAttribute('aria-label',card.getAttribute('aria-label'));
      dialog.showModal();player.play().catch(()=>{});
    },options));
    dialog.querySelector('.nr-ugc__close').addEventListener('click',close,options);
    dialog.addEventListener('click',event=>{if(event.target===dialog){const r=dialog.getBoundingClientRect();if(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom)close();}},options);
    dialog.addEventListener('close',()=>{stop();opener?.focus({preventScroll:true});},options);
    player.addEventListener('error',()=>{if(player.hasAttribute('src'))error.hidden=false;},options);
    document.addEventListener('visibilitychange',()=>{if(document.hidden)player.pause();},options);
    for(const [button,direction]of [[prev,-1],[next,1]])button.addEventListener('click',()=>{
      const step=cards.length>1?cards[1].offsetLeft-cards[0].offsetLeft:rail.clientWidth;
      rail.scrollBy({left:direction*step,behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'instant':'smooth'});
    },options);
    rail.addEventListener('scroll',update,{...options,passive:true});
    resizeObserver=new ResizeObserver(update);resizeObserver.observe(rail);update();
    controller.signal.addEventListener('abort',()=>{close();stop();},{once:true});
  }
  function mount(){
    const fresh=[...document.querySelectorAll('[data-nr-product-ugc]')].find(node=>node!==content);
    if(fresh){controller?.abort();resizeObserver?.disconnect();content?.remove();content=fresh;owner=fresh.closest('.shopify-section');init(content);}
    const slot=document.querySelector('[data-nr-product-section] [data-nr-ugc-slot]');
    if(content&&slot){slot.append(content);content.hidden=false;}
    if(owner)owner.hidden=true;
  }
  mount();
  document.addEventListener('nr:product:change',mount);
  document.addEventListener('shopify:section:load',mount);
  document.addEventListener('shopify:section:unload',event=>{if(event.target===owner){controller?.abort();resizeObserver?.disconnect();content?.remove();content=null;owner=null;}});
  document.addEventListener('shopify:section:select',event=>{if(event.target===owner)content?.scrollIntoView({block:'center',behavior:'instant'});});
  document.addEventListener('shopify:block:select',event=>{const card=content?.querySelector('[data-nr-ugc-block="'+event.detail.blockId+'"]');card?.scrollIntoView({block:'center',inline:'center',behavior:'instant'});});
})();
